<template>
  <div>
    <input :id="id" type="checkbox" v-model="modeDarktest" v-on:change="changeMode()">
    <label :for="id" class="check-trail">
      <span class="check-handler"></span>
    </label>
  </div>
    
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'SwitchMode',
    data() {
      return {
       // modeDark:false,
      }
    }  ,
    props:{
      id:String,
    },

    computed: {
      ...mapGetters({
        modeDark: 'layout/getmodeDark',
      }),

      modeDarktest:{
        get: function () { return this.modeDark},
        set: function (newValue) {  this.setmodeDark(newValue) }
      }

    },
    methods:{
      ...mapActions('layout', ['setmodeDark']),

      changeMode(){

        if(this.modeDark){
          localStorage.setItem('modeDark',true)
          document.querySelector("#app").classList.add('darkMode')
          console.log("darkMode",this.modeDark)

        }else
        {
          localStorage.setItem('modeDark',false)
          document.querySelector("#app").classList.remove('darkMode')
          console.log("darkMode",this.modeDark)

        }

      }
    },
    mounted(){
      if(localStorage.getItem('modeDark') && localStorage.getItem('modeDark') === 'true'){
        this.setmodeDark(true)
        this.changeMode(true)
      }else{
        localStorage.setItem('modeDark',false)
        this.setmodeDark(false)
        this.changeMode(false)

      }
    },

  };
</script>

<style scoped lang="scss">
  $white: #ecf0f1;
  $dark: #383838 ;
  $BG: #cacaca;
  $transition: all .5s ease;
  $width: 47px;
  $height: 25px;
  $widthHandle:23px;


  /* Hide the input */
  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  .check-trail {
    display: flex;
    align-items: center;
    width: $width;
    height: $height;
    background: $BG;
    border-radius: 2.5em;
    transition: $transition;
    cursor: pointer;
  }
  .check-handler {
    display: flex;
    justify-content: center;
    align-items: center;
    width: $widthHandle;
    height: $widthHandle;
    background: $white;
    border-radius: 50%;
    transition: $transition;
    box-shadow: 0 0 8px rgba(0,0,0,0.3);
    margin-left: 0.1em;
  &:before {
    content:"\e922";
    font-family: 'demo-icon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
   }
  }
  input[type="checkbox"]:checked + .check-trail {
    background: #a1a1a1;
  .check-handler {
    margin-left: 50%;
    background: $dark;
  &::before {
     color: white!important;
     content:"\e921";
    font-family: 'demo-icon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  }
 }

</style>



// WEBPACK FOOTER //
// src/components/CustomComponents/SwitchMode.vue